import prepareActionTypes from '../../helpers/prepareActionTypes';

export default prepareActionTypes(
  {
    SUPPORT: {
      INVALID: '',
      REQUESTING: '',
      FAILURE: '',
      SUCCESS: '',
    },
  },
  ['SUPPORT']
);
